<script setup lang="ts">
import PdsIcon from '@/components/pds/PdsIcon.vue';
import type { PdsIconName } from '@/components/pds/icons';
import PdsToast from '@/components/pds/PdsToast.vue';
import PdsToastButton from '@/components/pds/PdsToastButton.vue';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  type PdsAnnouncement,
  usePdsOrdersStore,
} from '../stores/orders.store';

const TONES: Record<
  PdsAnnouncement['tone'],
  { icon: PdsIconName; badge: string }
> = {
  success: { icon: 'check', badge: 'bg-croissance text-white' },
  new: { icon: 'plus', badge: 'bg-primaire text-primaire-encre' },
  info: { icon: 'arrow-right', badge: 'bg-pan-relief text-pan-encre' },
  alert: { icon: 'close', badge: 'bg-alerte text-alerte-encre' },
};

const store = usePdsOrdersStore();
const route = useRoute();
const router = useRouter();

const orderPath = (orderId: string) => `/commande/${orderId}`;

// « Voir » mène à la liste annoncée, sinon à la commande elle-même.
const target = computed(() => {
  const { to, orderId } = store.announcement ?? {};
  return to ?? (orderId ? orderPath(orderId) : undefined);
});

const open = (path: string) => {
  store.dismissAnnouncement();
  router.push(path);
};
</script>

<template>
  <PdsToast
    v-if="store.announcement"
    :key="store.announcement.id"
    position="top"
    :title="store.announcement.title"
    data-notice
  >
    <template #icon>
      <span
        class="flex size-9 shrink-0 items-center justify-center rounded-full"
        :class="TONES[store.announcement.tone].badge"
      >
        <PdsIcon
          :name="TONES[store.announcement.tone].icon"
          :size="20"
          :stroke="2.2"
        />
      </span>
    </template>
    {{ store.announcement.text }}
    <template #aside>
      <PdsToastButton
        v-if="target && route.path !== target.split('?')[0]"
        solid
        @click="open(target)"
        >Voir</PdsToastButton
      >
      <PdsToastButton @click="store.dismissAnnouncement()"
        >Fermer</PdsToastButton
      >
    </template>
  </PdsToast>
</template>
